// extracted by mini-css-extract-plugin
module.exports = {"navWidthCollapse":"70px","navWidthExpanded":"290px"};